var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGematsu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-0.5 -0.5 41 41",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.49,10.82c.13,0,.2-.05.2-.17V.17c0-.1-.07-.15-.2-.17H4.28A4.28,4.28,0,0,0,0,4.28V35.4a4.29,4.29,0,0,0,4.28,4.29H39.49c.13,0,.2-.06.2-.17V14.75c0-.11-.07-.17-.2-.19H15.94c-.09,0-.15.06-.17.19v10.3a.17.17,0,0,0,.17.16H27.7v3.65H12v-18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGematsu);
export default __webpack_public_path__ + "static/media/gematsu.f5a1da05898e2d5c6f45cb3285d57560.svg";
export { ForwardRef as ReactComponent };